<rask-container-block>
  <ng-container header>
    <rask-header size="2" underline>
      {{ 'TPL_FILTER_HEADER' | translate }}
      <span class="small-text">
        @if (nrFiltereadeAos !== null) {
          <span>Hittade {{ nrFiltereadeAos }} av {{ source.length }}
          arbetsordrar</span>
        }
        @if (nrFiltereadeAos === null) {
          <span>Hittade {{ source.length }} arbetsordrar</span>
        }
      </span>
    </rask-header>
  </ng-container>
  @if (isLoaded) {
    <div class="filter-container">
      <form [formGroup]="form" autocomplete="off">
        <rask-tpl-fritext-filter
          [form]="form"
          [filterContext]="filterContext">
        </rask-tpl-fritext-filter>
        <rask-tpl-redovisningshanvisning-filter
          [form]="form"
          [filterContext]="filterContext">
        </rask-tpl-redovisningshanvisning-filter>
        <rask-tpl-transportforetag-filter
          [form]="form"
          [filterContext]="filterContext"
          [dataSource]="source">
        </rask-tpl-transportforetag-filter>
        <rask-tpl-destinerad-filter
          [form]="form"
          [filterContext]="filterContext">
        </rask-tpl-destinerad-filter>
        <rask-tpl-transporthandelse-filter
          [form]="form"
          [filterContext]="filterContext">
        </rask-tpl-transporthandelse-filter>
        <rask-tpl-transporttilldelad-filter
          [form]="form"
          [filterContext]="filterContext">
        </rask-tpl-transporttilldelad-filter>
        <rask-tpl-vaglager-filter
          [form]="form"
          [filterContext]="filterContext"
          [dataSource]="source">
        </rask-tpl-vaglager-filter>
        <rask-tpl-lageralder-filter
          [form]="form"
          [filterContext]="filterContext">
        </rask-tpl-lageralder-filter>
        <rask-tpl-nasfranvag-filter
          [form]="form"
          [filterContext]="filterContext">
        </rask-tpl-nasfranvag-filter>
        <rask-tpl-mottagningsplats-filter
          [form]="form"
          [filterContext]="filterContext"
          [dataSource]="source">
        </rask-tpl-mottagningsplats-filter>
        <rask-tpl-valbara-mottagningsplatser-filter
          [form]="form"
          [filterContext]="filterContext"
          [dataSource]="source">
        </rask-tpl-valbara-mottagningsplatser-filter>
        <rask-tpl-avstand-filter
          [form]="form"
          [filterContext]="filterContext">
        </rask-tpl-avstand-filter>
        <rask-tpl-volym-filter
          [form]="form"
          [filterContext]="filterContext">
        </rask-tpl-volym-filter>
        <rask-tpl-handelssortiment-filter
          [form]="form"
          [filterContext]="filterContext"
          [dataSource]="source">
        </rask-tpl-handelssortiment-filter>
        <rask-tpl-maskinlag-filter
          [form]="form"
          [filterContext]="filterContext">
        </rask-tpl-maskinlag-filter>
        <rask-tpl-produktionsstatus-filter
          [form]="form"
          [filterContext]="filterContext"
          [dataSource]="source">
        </rask-tpl-produktionsstatus-filter>
        <rask-tpl-anskaffningsform-filter
          [form]="form"
          [filterContext]="filterContext"
          [dataSource]="source">
        </rask-tpl-anskaffningsform-filter>
        <rask-tpl-affarsform-filter
          [form]="form"
          [filterContext]="filterContext"
          [dataSource]="source">
        </rask-tpl-affarsform-filter>
        <rask-tpl-tillganglighet-filter
          [form]="form"
          [filterContext]="filterContext"
          [dataSource]="source">
        </rask-tpl-tillganglighet-filter>
        <rask-tpl-produktionsomrade-filter
          [form]="form"
          [filterContext]="filterContext"
          [dataSource]="source">>
        </rask-tpl-produktionsomrade-filter>
        <rask-tpl-destineringsomrade-filter
          [form]="form"
          [filterContext]="filterContext"
          [dataSource]="source">
        </rask-tpl-destineringsomrade-filter>
        @if (isTransportsattBransle) {
          <rask-tpl-skotningstid-filter
            [form]="form"
            [filterContext]="filterContext">
          </rask-tpl-skotningstid-filter>
        }
        @if (isTransportsattBransle) {
          <rask-tpl-skordningstid-filter
            [form]="form"
            [filterContext]="filterContext">
          </rask-tpl-skordningstid-filter>
        }
        <button [hidden]="true" type="submit"></button>
      </form>
    </div>
  }
  <ng-container footer>
    <rask-button aid="buttonFilter" color="primary" (click)="applyFilter()">Filtrera</rask-button>
    <rask-button aid="buttonRensa" color="secondary" (click)="reset(true)" negative>Rensa</rask-button>
  </ng-container>
</rask-container-block>
